export default __webpack_public_path__ + "static/media/logo-aciso.92866e5e.png";